(() => {
  const initSwiper = (root) => {
    // Initialize Swiper for curated kit
    const swiperEl = root.querySelector('[data-curated-kit-swiper]');
    if (!swiperEl) return;
    
    // Wait for Swiper to be available
    if (typeof Swiper === 'undefined') {
      setTimeout(() => initSwiper(root), 100);
      return;
    }
      const ctaSection = root.querySelector('.curated-kit-cta');
      const prevButton = ctaSection?.querySelector('.curated-kit-swiper-button-prev');
      const nextButton = ctaSection?.querySelector('.curated-kit-swiper-button-next');
      const wrapperEl = swiperEl.querySelector('.curated-kit-products .swiper-wrapper') || swiperEl.querySelector('.swiper-wrapper');

      function updateArrowVisibility(swiperInstance) {
        if (!prevButton || !nextButton) return;

        if (swiperInstance.isLocked) {
          // Both disabled - hide both
          prevButton.classList.add('is-hidden');
          nextButton.classList.add('is-hidden');
          prevButton.classList.remove('swiper-button-disabled');
          nextButton.classList.remove('swiper-button-disabled');
          if (wrapperEl) wrapperEl.classList.remove('is-swipable');
          return;
        }

        const isBeginning = swiperInstance.isBeginning;
        const isEnd = swiperInstance.isEnd;

        // If both are disabled, hide both
        if (isBeginning && isEnd) {
          prevButton.classList.add('is-hidden');
          nextButton.classList.add('is-hidden');
          prevButton.classList.remove('swiper-button-disabled');
          nextButton.classList.remove('swiper-button-disabled');
          if (wrapperEl) wrapperEl.classList.remove('is-swipable');
        } else {
          // At least one is enabled - use opacity for disabled ones (swipable: show arrows)
          if (wrapperEl) wrapperEl.classList.add('is-swipable');
          if (isBeginning) {
            prevButton.classList.add('swiper-button-disabled');
            prevButton.classList.remove('is-hidden');
          } else {
            prevButton.classList.remove('swiper-button-disabled');
            prevButton.classList.remove('is-hidden');
          }

          if (isEnd) {
            nextButton.classList.add('swiper-button-disabled');
            nextButton.classList.remove('is-hidden');
          } else {
            nextButton.classList.remove('swiper-button-disabled');
            nextButton.classList.remove('is-hidden');
          }
        }
      }

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        freeMode: false,
        centeredSlides: false,
        resistance: true,
        resistanceRatio: 0.5,
        watchOverflow: true,
        preventInteractionOnTransition: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          0: {
            slidesPerView: 'auto',
            spaceBetween: 20,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
          },
          481: {
            slidesPerView: 'auto',
            spaceBetween: 20,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
          768: {
            slidesPerView: 'auto',
            spaceBetween: 20,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
        on: {
          init: function () {
            this.update();
            updateArrowVisibility(this);
          },
          resize: function () {
            this.update();
            updateArrowVisibility(this);
          },
          slideChange: function () {
            updateArrowVisibility(this);
          },
          breakpoint: function () {
            this.update();
            updateArrowVisibility(this);
          },
          imagesReady: function () {
            this.update();
            updateArrowVisibility(this);
          },
        },
      });

      // Update on window resize and orientation change
      let resizeTimer;
      const handleResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          swiper.update();
          swiper.updateSlidesClasses();
          updateArrowVisibility(swiper);
        }, 250);
      };

      window.addEventListener('resize', handleResize);
      window.addEventListener('orientationchange', handleResize);
      
      // Also handle when images load (in case they affect layout)
      const images = swiperEl.querySelectorAll('img');
      images.forEach(img => {
        if (!img.complete) {
          img.addEventListener('load', handleResize);
        }
      });
    };

  const updatePricing = (root) => {
    const section = root.closest('[data-curated-kit-section]');
    if (!section) return;
    
    const productCards = section.querySelectorAll('.product-card[data-product-id]');
    const pricingContainer = section.querySelector('.curated-kit-pricing');
    const priceElement = pricingContainer?.querySelector('.curated-kit-price');
    const comparePriceElement = pricingContainer?.querySelector('.curated-kit-price-compare');
    const outOfStockNote = section.querySelector('.curated-kit-out-of-stock-note');
    
    if (!pricingContainer || !priceElement) return;
    
    let totalPrice = 0;
    let totalComparePrice = 0;
    let outOfStockCount = 0;
    let hasComparePrice = false;
    
    productCards.forEach((card) => {
      const cardForm = card.querySelector('form.product-card-form');
      if (!cardForm) return;
      
      const addButton = cardForm.querySelector('.product-card-add-button');
      // Exclude only when truly out of stock; do not exclude when button is disabled due to add-to-cart loading
      const isLoading = addButton && addButton.getAttribute('data-loading') === 'true';
      const isAvailable = addButton && (!addButton.disabled || isLoading);
      
      if (!isAvailable) {
        outOfStockCount++;
        return;
      }
      
      // Get price from the product card price element (data-price is in cents)
      const priceElement = card.querySelector('.product-card-price-sale[data-price]');
      if (priceElement) {
        const price = parseInt(priceElement.getAttribute('data-price'), 10);
        if (!isNaN(price)) {
          totalPrice += price;
          
          // Check for compare at price
          const comparePriceElement = card.querySelector('.product-card-price-original');
          if (comparePriceElement) {
            // Extract price from displayed text and convert to cents
            const compareText = comparePriceElement.textContent.trim();
            const compareMatch = compareText.match(/[\d,]+\.?\d*/);
            if (compareMatch) {
              const compareValue = Math.round(parseFloat(compareMatch[0].replace(/,/g, '')) * 100);
              if (compareValue > price) {
                totalComparePrice += compareValue;
                hasComparePrice = true;
              } else {
                totalComparePrice += price;
              }
            } else {
              totalComparePrice += price;
            }
          } else {
            totalComparePrice += price;
          }
        }
      }
    });
    
    // Format money - try to use existing formatMoney function, otherwise format manually
    const formatMoneyValue = (cents) => {
      // Check for global formatMoney function (from global.js)
      if (typeof window.formatMoney === 'function') {
        return window.formatMoney(cents);
      }
      // Fallback: format manually to match Shopify's typical format
      const dollars = (cents / 100).toFixed(2);
      // Check existing price format to match style
      const firstPriceElement = section.querySelector('.product-card-price-sale');
      if (firstPriceElement) {
        const existingPrice = firstPriceElement.textContent.trim();
        // If existing prices use $, use $; otherwise use the same format
        if (existingPrice.includes('$')) {
          return `$${parseFloat(dollars).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }
      }
      // Default format
      return `$${parseFloat(dollars).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };
    
    priceElement.textContent = formatMoneyValue(totalPrice);
    priceElement.setAttribute('aria-label', `Total price ${formatMoneyValue(totalPrice)}`);
    
    // Update compare price
    if (hasComparePrice && totalComparePrice > totalPrice) {
      if (!comparePriceElement) {
        const newComparePrice = document.createElement('span');
        newComparePrice.className = 'curated-kit-price-compare';
        newComparePrice.setAttribute('aria-label', 'Original price');
        pricingContainer.insertBefore(newComparePrice, priceElement);
        pricingContainer.querySelector('.curated-kit-price-compare').textContent = formatMoneyValue(totalComparePrice);
      } else {
        comparePriceElement.textContent = formatMoneyValue(totalComparePrice);
      }
    } else if (comparePriceElement) {
      comparePriceElement.remove();
    }
    
    // Update out-of-stock note
    if (outOfStockNote) {
      if (outOfStockCount > 0) {
        const itemText = outOfStockCount === 1 ? 'item' : 'items';
        outOfStockNote.textContent = `This curated kit has ${outOfStockCount} ${itemText} out of stock. Pricing reflects in-stock products only.`;
        outOfStockNote.style.display = 'block';
      } else {
        outOfStockNote.style.display = 'none';
      }
    }
  };

  const init = (root) => {
    // Initialize Swiper
    initSwiper(root);

    const form = root.querySelector('[data-curated-kit-form]');
    if (!form) return;
    
    // Initialize pricing calculation
    updatePricing(root);
    
    // Listen for variant changes on product cards
    const section = root.closest('[data-curated-kit-section]');
    if (section) {
      // Listen for variant changes via custom events or DOM mutations
      section.addEventListener('variant-change', () => {
        updatePricing(root);
      });
      
      // Also listen for button state changes (availability changes)
      const observer = new MutationObserver(() => {
        updatePricing(root);
      });
      
      const productCards = section.querySelectorAll('.product-card[data-product-id]');
      productCards.forEach((card) => {
        const addButton = card.querySelector('.product-card-add-button');
        if (addButton) {
          observer.observe(addButton, {
            attributes: true,
            attributeFilter: ['disabled', 'class']
          });
        }
        
        // Also observe price changes
        const priceElement = card.querySelector('.product-card-price-sale[data-price]');
        if (priceElement) {
          observer.observe(priceElement, {
            attributes: true,
            attributeFilter: ['data-price']
          });
        }
      });
      
      // Update pricing periodically to catch any missed changes
      setInterval(() => {
        updatePricing(root);
      }, 1000);
    }

    // Handle form submission for adding all products to cart
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const button = form.querySelector('.curated-kit-add-all-button');
      const buttonText = form.querySelector('.curated-kit-add-all-button-text');
      const errorNote = form.querySelector('.curated-kit-error-note');
      
      if (!button || !buttonText) return;

      if (errorNote) {
        errorNote.textContent = '';
        errorNote.style.display = 'none';
      }
      
      // Get the cart drawer (same as product-form does)
      const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
      // Disable button during submission
      const originalText = buttonText.textContent;
      button.disabled = true;
      buttonText.textContent = 'Adding...';
      
      try {
        // Update form inputs with currently selected variants from product cards
        // The form has initial items, but we need to sync with current selections
        const section = root.closest('[data-curated-kit-section]');
        if (!section) {
          throw new Error('Curated kit section not found');
        }
        
        const productCards = section.querySelectorAll('.product-card[data-product-id]');
        const formItems = [];
        let itemIndex = 0;
        
        productCards.forEach((card) => {
          const cardForm = card.querySelector('form.product-card-form');
          if (!cardForm) return;
          
          const variantInput = cardForm.querySelector('input[data-variant-id]');
          if (!variantInput || !variantInput.value) return;
          
          const variantId = parseInt(variantInput.value, 10);
          if (!variantId || isNaN(variantId)) return;
          
          const addButton = cardForm.querySelector('.product-card-add-button');
          const isAvailable = addButton && !addButton.disabled;
          
          if (isAvailable) {
            formItems.push({ id: variantId, quantity: 1, index: itemIndex });
            itemIndex++;
          }
        });
        
        if (formItems.length === 0) {
          throw new Error('No available items to add');
        }
        
        // Update form inputs with current selections
        // Remove existing item inputs
        form.querySelectorAll('input[name^="items["]').forEach(input => input.remove());
        
        // Add updated item inputs
        formItems.forEach(item => {
          const idInput = document.createElement('input');
          idInput.type = 'hidden';
          idInput.name = `items[${item.index}][id]`;
          idInput.value = item.id;
          form.appendChild(idInput);
          
          const qtyInput = document.createElement('input');
          qtyInput.type = 'hidden';
          qtyInput.name = `items[${item.index}][quantity]`;
          qtyInput.value = item.quantity;
          form.appendChild(qtyInput);
        });
        
        // Use FormData from the form directly (exact same approach as product-form)
        const config = typeof fetchConfig !== 'undefined' 
          ? fetchConfig('javascript')
          : {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/javascript'
              }
            };
        
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type']; // Required when using FormData
        
        const formData = new FormData(form);
        
        // Include sections if cart drawer exists (same as product-form)
        if (cartDrawer) {
          const sectionsToRender = cartDrawer.getSectionsToRender();
          const sectionIds = sectionsToRender.map(section => section.id);
          formData.append('sections', sectionIds.join(','));
          formData.append('sections_url', window.location.pathname);
          cartDrawer.setActiveElement(document.activeElement);
        }
        
        config.body = formData;
        
        // Use cart_add_url like product-form does (this is /cart/add.js)
        const cartAddUrl = window.routes?.cart_add_url || '/cart/add.js';
        const response = await fetch(cartAddUrl, config);
        
        if (response.status === 429) {
          throw new Error('RATE_LIMIT_429');
        }
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || errorData.message || 'Failed to add items to cart');
        }
        
        const data = await response.json();
        
        // Check for errors in response (same as product-form)
        if (data.status) {
          throw new Error(data.description || 'Failed to add items to cart');
        }
        
        // If no cart drawer, redirect to cart page (same as product-form)
        if (!cartDrawer) {
          window.location = window.routes?.cart_url || '/cart';
          return;
        }
        
        // Publish cart update event (same as product-form)
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {source: 'curated-kit'});
        }
        
        // Update the cart drawer (same as product-form - no modifications needed)
        cartDrawer.renderContents(data);
        
        // Explicitly open the cart drawer after updating
        // renderContents has conditional logic that might not open it for curated-kit
        setTimeout(() => {
          cartDrawer.open();
        }, 100);
        
        // Remove is-empty class if present (same as product-form)
        if (cartDrawer.classList.contains('is-empty')) {
          cartDrawer.classList.remove('is-empty');
        }
        
        // Show success message
        buttonText.textContent = 'Added to cart';
        setTimeout(() => {
          buttonText.textContent = originalText;
          button.disabled = false;
        }, 2000);
        
      } catch (error) {
        console.error('Error adding items to cart:', error);
        
        // Show user-friendly error message
        let errorMessage = 'There has been an error. Please try again!';
        if (error.message === 'RATE_LIMIT_429' || error.message.includes('429')) {
          errorMessage = 'We have detected unusual or rapid cart changes. Please try again, and if this happens again, wait a few minutes before re-adding the items to your cart. We apologize for any inconvenience due to this technical limitation.';
        } else if (error.message) {
          if (error.message.includes('out of stock')) {
            errorMessage = 'Items out of stock';
          } else if (error.message.includes('No items')) {
            errorMessage = 'No items to add';
          } else if (error.message.startsWith('Unexpected token')) {
            errorMessage = 'There has been an error. Please try again!';
          } else {
            errorMessage = error.message;
          }
        }
        
        if (errorNote) {
          errorNote.textContent = errorMessage;
          errorNote.style.display = 'block';
        }
        buttonText.textContent = originalText;
        button.disabled = false;
      }
    });
  };

  // Initialize all curated kit sections
  document.querySelectorAll('[data-curated-kit-section]').forEach((root) => {
    if (root.dataset.curatedKitInit === '1') return;
    root.dataset.curatedKitInit = '1';
    init(root);
  });
  
  // Also initialize on dynamic content updates
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('[data-curated-kit-section]').forEach((root) => {
        if (root.dataset.curatedKitInit === '1') return;
        root.dataset.curatedKitInit = '1';
        init(root);
      });
    });
  }
})();
